import { render, staticRenderFns } from "./ProjectsArchivedPage2.vue?vue&type=template&id=a1a9e16c&lang=pug&"
import script from "./ProjectsArchivedPage2.vue?vue&type=script&lang=js&"
export * from "./ProjectsArchivedPage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports